import React from "react";
import { Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";

const COLORS = {
  "Active User (20/6)": "green",
  "Active User(8/2)": "blue",
  "Inactive User Nurturing": "red",
  "Logged In": "yellow",
  Registered: "purple",
};
const UserComponent = ({ lead }) => {
  const navigate = useNavigate();
  return (
    <div className="col-6 p-1">
      <div>
        <div
          onClick={() =>
            navigate(`/admin/user-activity?tab=13&userid=${lead?._id}`)
          }
          className="pointer"
          style={{ border: "1px" }}
        >
          <Avatar
            src={lead.avatar}
            sx={{
              width: 40,
              height: 40,
              padding: 0,
              color: COLORS[lead.userCategory],
            }}
          >
            {lead.name && lead.name[0] && lead.name[0]}
          </Avatar>
          <p style={{ fontSize: "14px" }}>
            {`${lead.name && lead.name.substring(0, 15)}`}
            <br />
            {`(${
              lead.insititute
                ? lead.insititute.institutename
                : lead.firstname + " " + lead.lastname
            }, ${
              lead.insititute ? lead.insititute?.location?.country : lead.type
            })`}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserComponent;
